import { toLower, upperFirst } from 'lodash';

export const convertToSentenceCase = (str: string): string => {
  return upperFirst(toLower(str));
};
